export default "__VITE_ASSET__Ds7K2$VR__"